import { ITypographyComponentProps, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './TextMessage.css';

interface ITextMessageProps {
  text: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLSpanElement>;
  textColor: ITypographyComponentProps['color'];
}

export const TextMessage: React.FC<ITextMessageProps> = ({ text, onClick, textColor }) => {
  return (
    <span className={styles['text_message']} data-name="ChatMessageLayout_text" onClick={onClick}>
      <UIText1 color={textColor}>{text}</UIText1>
    </span>
  );
};
